export const ErrorMessages = {
  MAX_LENGTH: "Title max length is 50 characters",
  TITLE_REGEX: "Title must be letters, numbers, space and ( ) _ - , .",
  TITLE_REGEX_ALERT: "Title must be letters, numbers, space and ( ) _ - , . & ' \"",
  REPORT_NAME_REGEX: "Report name must be letters, numbers, space and ( ) _ - , .",
  INCLUDED_INVALID_PRODUCER_IDS: "You have included invalid Producer IDs",
  SORRY_ERROR: "We’re really sorry!",
  SMT_WRONG_ERROR: "Something must have gone wrong. Please reload this page and try again!",
  SUB_TITLE_MAX_LENGTH: "Sub-title max length is 100 characters",
  SUB_TITLE_REGEX: "Sub-title must be letters, numbers, space and ( ) _ - , .",
  ERROR_REGEX: "must be letters, numbers, space and ( ) _ - , .",
  ERROR_MAX_LENGTH: "Exceed max length (50)",
  REPORT_NAME_MAX_LENGTH: "Report name max length is 50 characters",
  REQUIRE_INFORMATION: "Required information",
  ERROR_KILL_DATA: "Please select one of the filters Country, Site, Species.",
  ERROR_ALREADY_APPROVE:
    "The form has already been approved. Please refresh page to get latest data.",
  ERROR_UPDATE: "The form has been updated. Please refresh page and try again",
  ERROR_ALREADY_UPDATE:
    "The form has already been updated. Please refresh the page to get the latest data.",
  ERROR_BLANK_COUNTRY_OR_SITE: "Please select at least one of the filters Country or Site.",
  ERROR_MAX_ROW_PRODUCER_IDS: "You have included too many Producer IDs. Maximum number is 500",
  ERROR_DUPLICATED_PRODUCER_IDS: "You have included duplicated Producer IDs",
  SCHEMES_INFORMATION_REQUIRED: "Schemes information is required.",
  ST_WRONG_AND_RELOAD_TITLE: "Something went wrong!",
  ST_WRONG_AND_RELOAD_MESSAGE:
    "There have been some issues with retrieving and processing the data. Please reload the page and try again.",
  PGA_FORM_EDIT_LOCK_TITLE: "Form Locked For Editing!",
  PGA_FORM_EDIT_LOCK_MESSAGE_1: "The form is currently being edited by ",
  PGA_FORM_EDIT_LOCK_MESSAGE_2: ". Please wait until they finish editing and try again.",
  PGA_FORM_REVIEW_LOCK_TITLE: "Form Currently Under Review!",
  PGA_FORM_REVIEW_LOCK_MESSAGE_1: "The form is currently being reviewed by ",
  PGA_FORM_REVIEW_LOCK_MESSAGE_2: ". Please wait until the review is complete and try again.",
  FAS_MEMBERSHIP_DUPLICATE:
    "A FAS Membership with this scheme and holding number already exists. Please check again.",
  FAS_DUPLICATE: "A FAS already exists. Please check again.",
  RESET_PASSWORD_EMPTY_EMAIL_PRODUCER:
    "It looks like the producer’s email is missing. Please check and try again.",
  MISSING_PERMISSION_TITLE: "Missing permission",
  MISSING_PERMISSION_MESSAGE:
    "It looks like you do not have permission to {0}. Please contact Advanced Admin for support.",
  ACTION_FAILED_MESSAGE: "Action failed. Please try again.",
  ERROR_TITLE: "Error",
  UNABLE_TO_PROCEED: "Unable to proceed",
  REVIEW_LINK_REQUEST_ERROR_MESSAGE:
    "This request can’t be processed right now. The request may have already been updated, is no longer available, or you don’t have permission to take action.",
};

export const SuccessMessages = {
  TITLE_MES_SUCCESS: "Congratulations!",
  CONTENT_MES_SUCCESS: "Your document has been uploaded.",
  UPDATE_ROLE_SUCCESS: "This account's access has been updated.",
  ASSIGN_SITES_SUCCESS: "The selected sites have been assigned to the user.",
  ASSIGN_FOLDERS_TO_USER_SUCCESS: "The selected folder(s) have been assigned to the user.",
  PGA_FORM_LIST_SUCCESS: "The PGA Form(s) has been approved successfully.",
  PGA_FORM_RESET_SUCCESS: "The PGA form has been reset successfully to be Not Started status.",
  REQUEST_APPROVED_MESSAGE: "Request approved successfully.",
  REQUEST_REJECTED_MESSAGE: "Request rejected.",
  REQUEST_WITHDRAWN_MESSAGE: "Request withdrawn.",
};

export const EditedFarmGroupMessage = {
  INFORMATION_HEADING: "Information",
  VIEWING_UPDATED_GROUP_ERROR:
    " It seems that the group has just been updated. Please refresh the page to get the latest data.",
  EDITING_UPDATED_GROUP_ERROR:
    "Sorry, this group has been updated. Please refresh to get the latest data.",
};

export const MyDocumentStatusMessages = {
  MY_DOCUMENT_UPLOAD_SUCCESS: "Your document has been successfully uploaded.",
  MY_DOCUMENT_UPDATE_SUCCESS: "Your document has been successfully updated.",
  MY_DOCUMENT_UPLOAD_FAILED:
    "There have been some issues with uploading your document. Please reload the page and try again.",
  MY_DOCUMENT_UPDATE_FAILED:
    "There have been some issues with updating your document. Please reload the page and try again.",
  MY_DOCUMENT_STM_WRONG: "Something went wrong!",
  MY_DOCUMENT_FILE_SIZE: "File size must not exceed 10MB. Please check again.",
  MY_DOCUMENT_FILE_EXT:
    "File type must be: PNG, JPG, JPEG, DOC, DOCX, PDF, XLSX, XLS, PPTX, PPT or CSV. Please check again.",
  MY_DOCUMENT_DELETE_DOCUMENT_ERR:
    "There have been some issues with deleting your document. Please reload the page and try again.",
  MY_DOCUMENT_DELETE_DOCUMENT_SUCCESS_TITLE: "Success!",
  MY_DOCUMENT_DELETE_DOCUMENT_SUCCESS_CONTENT: "Your document has been deleted.",
  MY_DOCUMENT_SUPPORTED_FILE_TEXT:
    "Supported file types: PNG, JPG, JPEG, DOC, DOCX, PDF, XLSX, XLS, PPTX, PPT, CSV.",
  MY_DOCUMENT_SUPPORTED_FILE_SIZE: "Maximum file size: 10MB.",
};

export const FlagNotesStatusMessages = {
  STM_WRONG: "Something went wrong!",
  SAVE_ERR:
    "There have been some issues with retrieving and processing the data. Please reload the page and try again.",
};

export const LinkRequestMessage = {
  CREATE_FAILED: "Action failed. Please try again.",
  CREATE_SUCCEED: "Request submitted successfully.",
  CONFIRM_FAILED: "Action failed. Please try again.",
  CONFIRM_SUCCEED: "Request confirmed successfully.",
  REJECT_FAILED: "Action failed. Please try again.",
  REJECT_SUCCEED: "Request rejected.",
  UNABLE_TO_PROCEED: "Unable to proceed",
  REVIEW_LINK_REQUEST_ERROR_MESSAGE: "This request can’t be processed right now. The request may have already been updated, is no longer available, or you don’t have permission to take action.",
  CONFIRMATION_HEADING: "Confirmation",
  WITHDRAW_MODAL_CONTENT: "Are you sure you want to withdraw this request?",
  CANCEL_BUTTON_TEXT: "No, cancel",
  CONFIRM_BUTTON_TEXT: "Yes, confirm",
  WITHDRAW_SUCCEED: "Request withdrawn.",
  LIMIT_REACHED_HEADING: "Link limit reached",
  LIMIT_REACHED_MODAL_CONTENT: "A link request cannot be created because one or both accounts have reached the maximum of 6 linked accounts (including pending requests).\nPlease double check, remove an existing link or withdraw a pending request before trying again.",
  UNLINK_SUCCEED: "Account unlinked successfully.",
  UNLINK_FAILED: "Action failed. Please try again.",
  UNLINK_CONFIRM_CONTENT: "You and this account will no longer be able to switch to each other.\nAre you sure you want to continue?",
};